export enum FlowKey {
    SignIn = 'SIGN_IN',
    SignUp = 'SIGN_UP',
}
